type DropdownState = Record<string, boolean>;

export const handleDropdownClick = (
  dropdownName: string,
  setDropdownState: React.Dispatch<React.SetStateAction<DropdownState>>
): void => {
  setDropdownState((prevState) => ({
    ...closeOtherDropdowns(dropdownName, prevState),
    [dropdownName]: !prevState[dropdownName],
  }));
};

const closeOtherDropdowns = (
  clickedDropdown: string,
  currentState: DropdownState
): DropdownState => {
  const updatedState: DropdownState = {};
  Object.keys(currentState).forEach((dropdown) => {
    if (dropdown !== clickedDropdown && currentState[dropdown]) {
      updatedState[dropdown] = false;
    }
  });
  return updatedState;
};
